import React, { useEffect, useState } from "react";
import PageTitle from "../components/PageTitle";
import SingleContentSection from "../components/Content/SingleContentSection";
import "./CreateCompanyPage.css";
import { BlogEntryItem } from "../utils/types/BlogEntryItem";

const CreateCompanyPage: React.FC = () => {
    const [currentItemContent, setCurrentItemContent] = useState<string>("");
    const [currentItemTitle, setCurrentItemTitle] = useState<string>("");
    useEffect(() => {
        const data = localStorage.getItem("main-articles");
        if (data) {
            const items = JSON.parse(data) as BlogEntryItem[];
            const item = items.filter(i => (i.blog.category === "mainContent" && i.meta.url == "zalozenie-a-zrusenie-spolocnosti"))[0];
            setCurrentItemContent(item.blog.content);
            setCurrentItemTitle(item.blog.title);
        }
    })
    
    return (
        <div>
            <PageTitle pageName="" desc="" id="zalozenie-a-zrusenie-spolocnosti"/>
            <SingleContentSection title={currentItemTitle} text={currentItemContent} itemUrl="zalozenie-a-zrusenie-spolocnosti"/>
        </div>
    )
}

export default CreateCompanyPage;